'use client';

import { useState } from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger
} from '~/components/ui/alert-dialog';
import { Button } from '~/components/ui/button';
import { Phone, Mail } from 'lucide-react';

export default function ShowContacts(props: {
  phone: string;
  email: string;
  phoneLabel: string;
  emailLabel: string;
  partnerInfo: string;
  doneLabel: string;
}) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClose = () => {
    setDialogOpen(false);
  };
  const handleOpen = () => {
    setDialogOpen(true);
  };

  return (
    <>
      <div className="flex flex-col sm:flex-row gap-2 pb-4 sm:pb-0">
        <Button onClick={handleOpen}>
          <Phone className="mr-2" size={18} />
          {props.phoneLabel}
        </Button>
        <Button variant="outline" onClick={handleOpen}>
          <Mail className="mr-2" size={18} />
          {props.emailLabel}
        </Button>
      </div>
      <AlertDialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{props.partnerInfo}</AlertDialogTitle>
            <AlertDialogDescription className='flex flex-col gap2'>
              <span>{props.email}</span>
              <span>{props.phone}</span>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction onClick={handleClose}>{props.doneLabel}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
